import gql from 'graphql-tag';

export const CLIENT_LOCALIZATIONS = gql`
	query clientLocalizationList($request: ClientLocalizationRequest!) {
		clientLocalizationList(request: $request) {
			name
			locType
			value
			englishValueResolved
			cultureInfoName
		}
	}
`;
